import React, { useState, useEffect, useCallback } from 'react';
import { getStyles } from '../../../theme/styles';
import { InputLabel, MenuItem, Select, FormControl } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import provisionService from '../../../services/ProvisionService';
import { ProductDTO } from '@beable/roster-backend-client-v1';

interface ProvisionSelectProps {
  productId: string;
  customerId: string;
  siteId: number;
  onChange: any;
  allOption?: boolean;
  disabled?: boolean;
  className?: string;
  variant?: 'filled' | 'outlined';
  inPanel?: boolean;
}

export default function ProductSelectList({ productId, customerId, siteId, onChange, allOption, disabled, className, variant, inPanel }: ProvisionSelectProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [products, setProducts] = useState<ProductDTO[]>([]);
  const memoOnChange = useCallback(onChange, []);

  useEffect(() => {
    const fetchProducts = async () => {
      const data = await provisionService.getSiteProducts(customerId, siteId);
      if (data) {
        setProducts(data);
        if(data.length === 1) {
          memoOnChange(data[0]);
        }
      }
      else setProducts([]);
    };
    fetchProducts();
  }, [customerId, siteId, memoOnChange]);

  const handleChange = (event: any) => {
    const selectedProduct = products.find((product) => product.id === event.target.value);
    if (onChange) {
      onChange(selectedProduct);
    }
  }

  return (
    <FormControl
      sx={className ? undefined : (inPanel ? styles.pFormControlPanel : styles.pFormControl)}
      className={className}
      variant={ variant || 'standard' }
    >
      <InputLabel htmlFor='productId'>Select Product</InputLabel>
      <Select
        variant={ variant || "standard" }
        value={(products.length && productId) || ''}
        onChange={handleChange}
        inputProps={{
          'name': 'productId',
          'id': 'productId',
          'data-testid': 'test-productId',
          'role': 'option'
        }}
        disabled={!siteId || disabled}>
        { allOption &&
          <MenuItem
            value='ALL'
            role='option'
          >All Products</MenuItem>
        }
        { !!products.length &&
          products.map((product: any) => (
            <MenuItem key={product.id} value={product.id} role='option'>
              {product.name}
            </MenuItem>
          ))
        }
        { !!customerId && !products.length &&
          <MenuItem key={0} value={0} role='option'>
              No Products found
          </MenuItem>
        }
      </Select>
    </FormControl>
  );
}
